import { render, staticRenderFns } from "./mobileAppBanner.vue?vue&type=template&id=520b523d&scoped=true&"
import script from "./mobileAppBanner.vue?vue&type=script&lang=js&"
export * from "./mobileAppBanner.vue?vue&type=script&lang=js&"
import style0 from "./mobileAppBanner.vue?vue&type=style&index=0&id=520b523d&prod&lang=scss&scoped=true&"
import style1 from "./mobileAppBanner.vue?vue&type=style&index=1&id=520b523d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b523d",
  null
  
)

export default component.exports